import { RELATED_PARTY_TYPES } from '../../../../../../../constants';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';

const { systemPropertyRecordType } = loanFormModel.formField;

class IsPropertyOwnerAnotherIndividual implements Rule {
  private index: number;

  get dependsOn(): string[] {
    return [`principals[${this.index}].${systemPropertyRecordType.name}`];
  }

  public setIndex(index: number): IsPropertyOwnerAnotherIndividual {
    this.index = index;
    return this;
  }

  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    return (
      application.principals?.[this.index]?.[systemPropertyRecordType.name] ===
      RELATED_PARTY_TYPES.INDIVIDUAL
    );
  }
}

export default new IsPropertyOwnerAnotherIndividual();
